import { useState, useEffect } from "react";
import { ColumnDef } from "@tanstack/react-table";
import Select from "react-select";
import apiService from "../../Services/apiService";
import Title from "./Title";
import Loading from "../General/Loading";
import AdvancedDataTable from "../../Components/General/Table";
import PopupGlobel from "../../PopModal/PopupGlobel";
type Category = {
  activateId: number;
  name: string;
};
const columns: ColumnDef<Category>[] = [
  {
    accessorKey: "name",
    header: "اسم النشاط",
  },
  {
    accessorKey: "activateId",
    header: "المعرف",
    enableHiding: true,
  },
];
const LinkActivatesBranches = () => {
  const [loading, setLoading] = useState(false);
  const [notUsedCategory, setnotUsedCategory] = useState<any[]>([]);
  const [usedCategory, setusedCategory] = useState<any[]>([]);
  const [isShowPopLink, setshowPopLink] = useState(false);
  const [isShowPopUnLink, setShowPopUnLink] = useState(false);
  const [shopId, setShopId] = useState("");
  const [selectedCatId, setSelectedCatId] = useState("0");
  const [shops, setShops] = useState<any[]>([]);
  // Global error
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const refreshData = async () => {
    try {
      setLoading(true);
      debugger;
      const result = await fetshCategory(0);
      if (result) {
        setnotUsedCategory(result.avalibalCategories || []);
        setusedCategory(result.linkedCategories || []);
      }
    } finally {
      setLoading(false);
    }
  };
  // Run once on mount
  useEffect(() => {
    if (shopId) {
      refreshData();
    }
    fetshShops();
  }, [shopId]);
  const fetshShops = async (): Promise<void> => {
    try {
      const result = await apiService.fetchGetData("api/GetShops", {});
      setShops(result.data);
    } catch (error) {
      console.error("Error fetching tags:", error);
      setShops([]); // Handle error case
    }
  };
  const fetshCategory = async (startIndex: number) => {
    try {
      const result = await apiService.fetchGetData(
        "api/GetLinkedActivitiesOrgs",
        { shopId: shopId },
      );

      console.log(result.avalibalCategories);
      console.log(result.linkedCategories);

      return result;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return null;
    }
  };
  const showPopLink = async (catId: string) => {
    setLoading(true);
    setSelectedCatId(catId);
    setshowPopLink(true);
    setLoading(false);
  };
  const showPopRemoveLink = async (catId: string) => {
    setLoading(true);
    setSelectedCatId(catId);
    setShowPopUnLink(true);
    setLoading(false);
  };
  const linkCategory = async (catId: string) => {
    try {
      debugger;
      setLoading(true);
      const result = await apiService.fetchGetData("api/LinkOrgActivities", {
        shopId: shopId,
        categoryId: catId,
      });
      if (result.isOk) {
        setSuccess("✅" + result.errAr);
        refreshData();
      } else setError("❌" + result.errAr);
      setshowPopLink(false);
      setLoading(false);
      return result;
    } catch (error) {
      setError("❌" + error);
      setshowPopLink(false);
      setLoading(false);
      return null;
    }
  };
  const deleteCategory = async (catId: string) => {
    try {
      setLoading(true);

      const result = await apiService.fetchGetData(
        "api/RemoveLinkOrgActivities",
        { shopId: shopId, categoryId: catId },
      );
      debugger;
      if (result.isOk) {
        setSuccess("✅" + result.errAr);
        refreshData();
      } else {
        setError("❌" + result.errAr);
      }

      setShowPopUnLink(false);
      return result;
    } catch (error) {
      console.error(error);
      setError("❌ Error occurred");
      return null;
    } finally {
      setLoading(false);
    }
  };

  const options = shops.map((item) => ({
    value: item.shopId,
    label: item.portName,
    data: item, // keep the whole object
  }));
  const handleChange = (option: any) => {
    if (option != null) {
      setLoading(true);
      setShopId(option.value);
      console.log("Selected Object:", option);
      console.log("Selected Value:", option.value);
      console.log("Selected Label:", option.label);
      //refreshData();
      setLoading(false);
    } else {
      setShopId("");
      setnotUsedCategory([]);
      setusedCategory([]);
    }
  };
  return (
    <>
      {loading && <Loading />}
      {isShowPopLink && (
        <PopupGlobel
          approveAction={() => linkCategory(selectedCatId)}
          cancelAction={() => {
            setshowPopLink(false);
          }}
          btnApproveTitle="ربط"
          btnCancelTitle="الغاء"
          title="تاكيد ربط المتجر بالنشاط"
          popupType={1}
        >
          <p>هل انت متاكد من عملية ربط النشاط بالمتجر؟ </p>
        </PopupGlobel>
      )}

      {isShowPopUnLink && (
        <PopupGlobel
          approveAction={() => deleteCategory(selectedCatId)}
          cancelAction={() => {
            setShowPopUnLink(false);
          }}
          btnApproveTitle="إزالة الارتباط"
          btnCancelTitle="الغاء"
          title="تاكيد الغاء ارتباط المتجر بالنشاط"
          popupType={2}
        >
          <p>هل انت متاكد من إزالة الارتباط ؟ </p>
        </PopupGlobel>
      )}
      <main className="relative pt-16 min-h-screen bg-surface">
        <div className="flex flex-col w-full h-full p-margin-desktop gap-gutter max-w-[1200px] mx-auto">
          <Title
            pageName="ربط المتاجر بالنشاطات"
            pageDesc=""
            isSearch={false}
          />
          <div
            className="flex items-center gap-4 bg-surface-container-lowest p-3 rounded-xl shadow-sm"
            style={{ position: "relative", zIndex: "1000" }}
          >
            <label className="font-label-md text-on-surface-variant whitespace-nowrap">
              اختيار اسم الجمعية:
            </label>
            <div className="w-80">
              <Select
                options={options}
                placeholder="🔍 حدد المتجر "
                isSearchable
                isClearable
                isMulti={false}
                menuPlacement="auto"
                onChange={handleChange}
                noOptionsMessage={() => "No results found"}
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    minHeight: "50px",
                    borderRadius: "12px",
                    borderColor: state.isFocused ? "#3B82F6" : "#E5E7EB",
                    boxShadow: state.isFocused
                      ? "0 0 0 3px rgba(59,130,246,0.2)"
                      : "none",
                    "&:hover": {
                      borderColor: "#3B82F6",
                    },
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected
                      ? "#3B82F6"
                      : state.isFocused
                        ? "#EFF6FF"
                        : "white",
                    color: state.isSelected ? "white" : "#111827",
                    cursor: "pointer",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    borderRadius: "12px",
                    overflow: "hidden",
                  }),
                }}
              />
            </div>
          </div>
          <br />
          <div>
            {error && (
              <div className="bg-red-100 text-red-700 p-4 rounded-lg">
                {error}
              </div>
            )}
            {success && (
              <div className="bg-green-100 text-green-700 p-4 rounded-lg">
                {success}
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 relative z-10">
            {/* Available Services Column */}

            <div className="bg-surface-container-lowest rounded-2xl shadow-lg flex flex-col overflow-hidden relative group">
              <div className="absolute top-0 right-0 w-2 h-full bg-surface-container-highest transition-colors group-hover:bg-primary" />
              <div className="p-6 pb-4 border-b border-surface-container-highest flex justify-between items-center bg-surface-muted">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                    <span className="material-symbols-outlined">
                      add_circle
                    </span>
                  </div>
                  <h2 className="font-headline-md text-deep-navy">
                    الخدمات المتاحة
                  </h2>
                </div>
                <span className="bg-surface-container-high text-on-surface-variant font-label-sm px-3 py-1 rounded-full">
                  {notUsedCategory.length} خدمة
                </span>
              </div>
              <div className="p-6 flex-1 flex flex-col gap-4">
                <AdvancedDataTable
                  data={notUsedCategory}
                  columns={columns}
                  title=""
                  btnTitle="ربط"
                  isShowBtn={true}
                  btnAction={showPopLink}
                  idName="activateId"
                />
              </div>
            </div>
            {/* Linked Services Column */}
            <div className="bg-surface-container-lowest rounded-2xl shadow-lg flex flex-col overflow-hidden relative group">
              <div className="absolute top-0 right-0 w-2 h-full bg-surface-container-highest transition-colors group-hover:bg-vibrant-orange" />
              <div className="p-6 pb-4 border-b border-surface-container-highest flex justify-between items-center bg-surface-muted">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-vibrant-orange/10 flex items-center justify-center text-vibrant-orange">
                    <span className="material-symbols-outlined">link</span>
                  </div>
                  <h2 className="font-headline-md text-deep-navy">
                    الخدمات المرتبطة
                  </h2>
                </div>
                <span className="bg-vibrant-orange text-on-primary font-label-sm px-3 py-1 rounded-full shadow-sm">
                  {usedCategory.length} خدمات
                </span>
              </div>
              <div className="p-6 flex-1 flex flex-col gap-4">
                <AdvancedDataTable
                  data={usedCategory}
                  columns={columns}
                  title=""
                  btnTitle="إزالة الارتباط"
                  isShowBtn={true}
                  btnAction={showPopRemoveLink}
                  btnActionType={2}
                  idName="activateId"
                />
              </div>
            </div>
          </div>
          {/* Background Decorative Elements */}
          <div className="fixed top-20 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl -z-10 pointer-events-none mix-blend-multiply" />
          <div className="fixed bottom-0 left-1/3 w-[500px] h-[500px] bg-vibrant-orange/5 rounded-full blur-3xl -z-10 pointer-events-none mix-blend-multiply" />
        </div>
      </main>
    </>
  );
};

export default LinkActivatesBranches;
